import React, {useEffect} from "react";
import {Dialog, DialogProps} from "~/components/Dialog";
import {Box} from "@mui/system";
import {Button} from "@mui/material";
import {useBooleanHistoryState} from "~/apps/core/utils";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";

type ConfirmActionDialogProps = DialogProps & {
    dialogId: string,
    dialogTitle?: React.ReactNode,
    confirmButtonText?: string,
    cancelButtonText?: string,
    children: React.ReactNode
    onConfirm?: () => void
}

const useStyles = makeStyles<PortTheme, ConfirmActionDialogProps>(theme => ({
    dialogContentText: {
        display: 'block',
        textAlign: 'center',
        '@media (min-width: 500px)': {
            padding: 5
        }
    },
    dialogPaperStyle: {
        maxWidth: 500
    }
}))

export const ConfirmActionDialog = (props: ConfirmActionDialogProps) => {
    const {onConfirm, children, open, onClose, confirmButtonText = 'Подтвердить', cancelButtonText = 'Отменить'} = props;

    const classes = useStyles(props);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            dialogContentTextProps={{classes: {root: classes.dialogContentText}}}
            dialogPaperStyle={classes.dialogPaperStyle}
            actions={
                <Box display="flex" flexDirection="row" justifyContent="space-between" gap={1}>
                    <Button size="small" fullWidth color="additionalSecondary" onClick={onClose}>
                        {cancelButtonText}
                    </Button>
                    <Button size="small" fullWidth color="additionalPrimary" onClick={onConfirm}>
                        {confirmButtonText}
                    </Button>
                </Box>
            }
        >
            {children}
        </Dialog>
    );
}
